"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var source_exports = {};
__export(source_exports, {
  classifyOpenApiSource: () => classifyOpenApiSource
});
module.exports = __toCommonJS(source_exports);
const urlOnly = /^https?:\/\/\S+$/i;
function classifyOpenApiSource(text) {
  const trimmed = text.trim();
  if (trimmed.length === 0) {
    return { kind: "empty", text };
  }
  if (urlOnly.test(trimmed)) {
    return { kind: "url", url: trimmed, text };
  }
  return { kind: "inline", text };
}
__name(classifyOpenApiSource, "classifyOpenApiSource");
//# sourceMappingURL=source.js.map
